import { httpClient } from '@/services/http/httpClient'

export type GetTenantPublicConfigsResponse = {
  msalClientId?: string | null
  msalAuthority?: string | null
  msalRedirectUri?: string | null
}

export async function getPublicConfigs(): Promise<GetTenantPublicConfigsResponse> {
  const { data } = await httpClient.get('/tennants/config/public')
  return {
    msalClientId: data.config?.msalClientId ?? null,
    msalAuthority: data.config?.msalAuthority ?? null,
    msalRedirectUri: data.config?.msalRedirectUri ?? null,
  }
}
